// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1FqQV","bigColWidth":"Table_bigColWidth__3FTq4","biggerColWidth":"Table_biggerColWidth__3C_T8","row":"Table_row__1ahhB","col":"Table_col__2wnU9"};